import { http } from "./config";
import authHeader from "./auth-header";

export default {
  consultar: (payload, page = 0, size = 10) =>
    http.post("/consulta-dinamica-dash/consultar", payload, {
      headers: authHeader(),
      params: { page, size },
    }),

  consultarXls: (payload) =>
    http.post("/consulta-dinamica-dash/consultar-xls", payload, {
      headers: authHeader(),
      responseType: "blob",
    }),
};
